import { ReactNode } from 'react'
import { AlertTriangle, CheckCircle, Info, XCircle, X } from 'lucide-react'
import type { StatusType } from './StatusCard'
import { ActionButton } from './ActionButton'

export interface AlertBannerProps {
  children: ReactNode
  variant?: StatusType
  action?: {
    label: string
    onClick: () => void
  }
  dismissible?: boolean
  onDismiss?: () => void
  className?: string
}

function getIcon(variant: StatusType) {
  const iconSize = 20
  switch (variant) {
    case 'success':
      return <CheckCircle size={iconSize} />
    case 'warning':
      return <AlertTriangle size={iconSize} />
    case 'error':
      return <XCircle size={iconSize} />
    case 'info':
    default:
      return <Info size={iconSize} />
  }
}

export function AlertBanner({
  children,
  variant = 'info',
  action,
  dismissible = false,
  onDismiss,
  className = '',
}: AlertBannerProps) {
  return (
    <div
      className={`alert-banner alert-banner--${variant} ${className}`}
      role="alert"
    >
      <span className="alert-banner__icon">{getIcon(variant)}</span>
      <div className="alert-banner__content">{children}</div>
      {action && (
        <ActionButton
          variant="ghost"
          size="sm"
          onClick={action.onClick}
          className="alert-banner__action"
        >
          {action.label}
        </ActionButton>
      )}
      {dismissible && (
        <button
          className="alert-banner__dismiss"
          onClick={onDismiss}
          aria-label="Cerrar"
        >
          <X size={18} />
        </button>
      )}
    </div>
  )
}
